export default "__VITE_ASSET__DB2vaghs__"